import { useState } from "react";
import notify from "devextreme/ui/notify";
import { requestERPLYData } from "../utils/requestERPLY";
import { formatParameters, partnerKey } from "../utils";

const useFetchParameters = () => {
  const [parameters, setParameters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchParameters = async (keys, isIframe) => {
    setIsLoading(true);

    let request;

    if (isIframe) {
      request = {
        request: "getConfParameters",
        clientCode: keys.clientCode,
        sessionKey: keys.sessionKey,
        partnerKey,
      };
    } else {
      request = {
        request: "getConfParameters",
        clientCode: keys.clientCode,
        partnerKey,
      };
    }

    try {
      const { data } = await requestERPLYData(request);
      if (data.status.responseStatus === "ok") {
        if (data.records.length) {
          setParameters(formatParameters(data.records[0]));
        } else {
          setParameters([]);
        }

        setIsLoading(false);
      } else {
        notify(`Error performing operation`, "error", 3000);
        setIsLoading(false);
      }
    } catch (error) {
      notify(`Error performing operation`, "error", 3000);
      setIsLoading(false);
    }
  };

  return {
    parameters,
    fetchParameters,
    isLoading,
  };
};

export default useFetchParameters;
